import request from '@/utils/request'

export default {
  /**
   * 获取自定义线下支付方法列表
   */
  getCustomOfflinePayMethods() {
    return request.get('/custom-offline-pay-methods/list/all')
  }
}
